export const GUIDELINE_1 =
  'The text in gray is a guidance on how to fill in the specific sections of the report. The guidance text must be removed before submitting for approval.\n' +
  'The change request ID will be assigned automatically by the system in sequential order and will not be immediately visible in the file preview.\n' +
  ' All placeholders in double curly brackets (e.g., {{variable}}) are populated automatically from the change request fields.';

export const GUIDELINE_2 =
  'Provide a summary description of what functional changes are applied and (if applicable) the purpose or reason for the change. Do not copy-paste detailed requirements here, only provide an overview. A specific version of the requirements document may be referenced.';
export const GUIDELINE_3 =
  'The budget, hours, and delivery date parameters are automatically populated from the fields filled out above in the change request. If a particular parameter is not changing, the corresponding line should be removed from the Markdown format.';
export const GUIDELINE_4 =
  'Provide a list of assumptions and constraints that were defined for estimating this change request. If no assumptions were made state this explicitly.';

export const CHANGE_REQUEST_TEMPLATE_FOOTER = `
\n
**{{companyName}}**

--------

**By:**           <span class='docu-sign-anchor'>client_initials_here_anchor</span>

**Name:**          {{ receiverFullName }}

**Title:**         {{ receiverTitle }}

**Date:**          <span class='docu-sign-anchor'>client_date_here_anchor</span>

Change Request Initial <span class='docu-sign-anchor'>client_sign_here_anchor</span>
`;
